import animationManager, {
  AnimationStatusCallbacks,
  makeSequence,
  SequenceStep,
} from "../../../../../../shared/services/animation-manager";
import { AnimationSequences } from "../../../../../../shared/utility/constants";

export function registerCloseDoubleDrawerSequence({
  onBackdropFadeOutEnd,
  onAnimationStarts,
  onAnimationEnds,
}: Required<AnimationStatusCallbacks> & {
  onBackdropFadeOutEnd;
}): void {
  const sequence: SequenceStep[] = [
    [
      {
        elementSelector: "phn-nd-double-drawer",
        onStart: onAnimationStarts,
        animation: {
          className: "closing-animation",
          cleanUpBeforeAnimation: (element) => {
            element.style.translate = "";
          },
        },
      },
      {
        elementSelector: "phn-nd-backdrop",
        animation: {
          className: "fade-out-animation",
          cleanUpBeforeAnimation: (element) => {
            element.style.opacity = "";
            element.style.backgroundColor = "";
          },
        },
        onEnd: () => {
          onBackdropFadeOutEnd();
          onAnimationEnds();
        },
      },
    ],
  ];

  animationManager.register(
    AnimationSequences.CLOSE_DOUBLE_DRAWER,
    makeSequence(sequence),
  );
}
